import { useContext } from "react";
import { type GetComplianceCaseQuery } from "~/graphql/supergraphTypes";
import { FundComparisonCard } from "~/pages/Compliance/CaseDetailsDrawer/Details/FundComparisonCard";
import { ComplianceRulesContext } from "../../complianceRulesContext";
import { CaseDetailsCard } from "./CaseDetailsCard";
import { EscalationDetailsCard } from "./EscalationDetailsCard";
import { RuleHitCard } from "./RuleHitCard";

interface Props {
  complianceCase: GetComplianceCaseQuery["complianceCase"] | undefined;
}
const Details = ({ complianceCase }: Props) => {
  const rules = useContext(ComplianceRulesContext);
  return (
    <>
      {rules.usesFundsComparison && <FundComparisonCard complianceCase={complianceCase} />}
      {rules.usesRuleHits && <RuleHitCard complianceCase={complianceCase} />}
      {rules.showPaymentDetails && <CaseDetailsCard complianceCase={complianceCase} />}
      {rules.showEscalationDetails && <EscalationDetailsCard complianceCase={complianceCase} />}
    </>
  );
};

export default Details;
